"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@headlessui/react");
var classnames_1 = require("classnames");
var theme_1 = require("../../theme");
var Icon_1 = require("../Icon");
var Typography_1 = require("../Typography");
var DropdownItem = function (_a) {
    var item = _a.item, renderItem = _a.renderItem, onClick = _a.onClick, indent = _a.indent, dataTestId = _a["data-testid"];
    var bgStateColors = (0, theme_1.useBackgroundStateColors)();
    var bgStateActiveColors = (0, theme_1.useBackgroundStateActiveColors)();
    return ((0, jsx_runtime_1.jsx)(react_1.Menu.Item, { children: function (_a) {
            var _b;
            var active = _a.active;
            if (renderItem) {
                return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: renderItem(item, active) });
            }
            return ((0, jsx_runtime_1.jsxs)("div", __assign({ onClick: onClick, className: (0, classnames_1.default)("\n            squid-rounded-component-dropdown-menu-border-radius \n            squid-px-4 \n            squid-py-2 \n            squid-flex \n            squid-gap-2 \n            squid-items-center\n            squid-justify-between\n            ", (_b = {
                        'squid-cursor-pointer': item.value
                    },
                    _b[bgStateActiveColors.base] = item.value && active,
                    _b[bgStateColors.base] = item.value && !active,
                    _b)), "data-testid": dataTestId }, { children: [item.leftIcon && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: item.leftIcon, variant: item.leftIconOutlined ? 'outline' : 'solid', size: "md" })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)('squid-flex squid-flex-1 squid-flex-col squid-justify-start', {
                            'squid-pl-6': !item.leftIcon && indent,
                        }) }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ strong: item.value && active, className: "squid-whitespace-nowrap", color: item.value && active ? 'on-base-active' : 'weaker' }, { children: item.label })), (0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ strong: false, color: "weaker", className: "squid-whitespace-nowrap" }, { children: item.helpText }))] })), item.rightIcon && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: item.rightIcon, variant: item.rightIconOutlined ? 'outline' : 'solid', size: "md", className: "squid-ml-6" }))] })));
        } }));
};
exports.default = DropdownItem;
